import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemCategory\DeleteItemCategoryController::deleteMethod
* @see app/Http/Controllers/ItemCategory/DeleteItemCategoryController.php
* @route '/api/item-category/item-category-delete/{itemCategory}'
*/
export const deleteMethod = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/item-category/item-category-delete/{itemCategory}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ItemCategory\DeleteItemCategoryController::deleteMethod
* @see app/Http/Controllers/ItemCategory/DeleteItemCategoryController.php
* @route '/api/item-category/item-category-delete/{itemCategory}'
*/
deleteMethod.url = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { itemCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { itemCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            itemCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        itemCategory: typeof args.itemCategory === 'object'
        ? args.itemCategory.id
        : args.itemCategory,
    }

    return deleteMethod.definition.url
            .replace('{itemCategory}', parsedArgs.itemCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\DeleteItemCategoryController::deleteMethod
* @see app/Http/Controllers/ItemCategory/DeleteItemCategoryController.php
* @route '/api/item-category/item-category-delete/{itemCategory}'
*/
deleteMethod.delete = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ItemCategory\DeleteItemCategoryController::undo
* @see app/Http/Controllers/ItemCategory/DeleteItemCategoryController.php
* @route '/api/item-category/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/item-category/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemCategory\DeleteItemCategoryController::undo
* @see app/Http/Controllers/ItemCategory/DeleteItemCategoryController.php
* @route '/api/item-category/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\DeleteItemCategoryController::undo
* @see app/Http/Controllers/ItemCategory/DeleteItemCategoryController.php
* @route '/api/item-category/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemCategory\DeleteItemCategoryController::undo
* @see app/Http/Controllers/ItemCategory/DeleteItemCategoryController.php
* @route '/api/item-category/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteItemCategoryController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteItemCategoryController